import { render, staticRenderFns } from "./GenresTitleBrief.vue?vue&type=template&id=5c92d3c6&scoped=true&"
import script from "./GenresTitleBrief.vue?vue&type=script&lang=js&"
export * from "./GenresTitleBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c92d3c6",
  null
  
)

export default component.exports